<template>
  <b-modal
    :visible="show"
    title="Reverse hold"
    centered
    no-close-on-backdrop
    @hide="$emit('cancel')"
  >
    <div v-if="hold">
      <p class="mb-3">
        You are about to <strong>reverse</strong> this hold. This will release the
        held funds back to the wallet's available balance.
      </p>
      <dl class="row mb-0">
        <dt class="col-5 text-muted">Hold ID</dt>
        <dd class="col-7 text-break">{{ hold.hold_id }}</dd>
        <dt class="col-5 text-muted">Wallet ID</dt>
        <dd class="col-7 text-break">{{ hold.wallet_id }}</dd>
        <dt class="col-5 text-muted">Amount</dt>
        <dd class="col-7">{{ formatAmount(hold.amount) }} {{ hold.currency_code }}</dd>
      </dl>
    </div>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="$emit('cancel')">Cancel</b-button>
      <!-- Reverse releases funds (not a permanent debit) — warning-styled to read
           distinctly from the Confirm modal's danger button. -->
      <b-button variant="warning" @click="$emit('reverse')">Reverse hold</b-button>
    </template>
  </b-modal>
</template>

<script>
import { formatAmount } from "@/utils/holds/formatters";

export default {
  name: "HoldReverseModal",
  props: {
    show: { type: Boolean, default: false },
    hold: { type: Object, default: null },
  },
  methods: {
    formatAmount,
  },
};
</script>
